<template>

    <div class="wrapper">
        <div name="card-error-modal" class="modal">
            <div class="touch" @click="onClose">

            </div>
            <div class="contents">
                <span class="title">카드 등록 실패</span>
                <div class="column">
                    <img style="width: 236px;" src="../../assets/card.png" />
                    <span class="error">{{ error }}</span>
                    <span class="static-error">잘못된 카드 정보를 반복 입력할 경우,<br>
                    모든 카드 거래가 중지될 수 있으니<br>
                    신중히 입력해 주세요.</span>
                </div>
                <div class="button" @click="onClose">카드 정보 재입력하기</div>
            </div>
        </div>
    </div>
    
</template>

<script>
// error modal 

export default {
    name: 'cardErrorModal',
    props: ['error'],
    methods: {
        onClose : function()
        {
            this.$emit('onClose');
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        box-sizing: border-box;
        z-index: 9999;
    }
    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 10;
        bottom: 0;
        box-sizing: border-box;

    }

    .touch {
        height: calc(100vh - 532px);
        width: 100vw;
    }
    .contents {
        background: #FFFFFF;
        height: 532px;
        width: calc(100% - 16px);
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding-top: 34px;
        padding-left: 16px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 116.667% */
    }
    .error {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 110% */
        margin-top: 30px;
    }
    .button {
        display: flex;
        width: calc(100% - 32px);
        height: 56px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-100, #1E1E1E);
        color: var(--Gray-00, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        position: absolute;
        bottom: 30px;
        cursor: pointer;
    }
    .column{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        margin-top: 50px;
    }
    .static-error {
        color: var(--Gray-60, #6B7684);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/CardErrorModal.vue